import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// * Kendo dependencies
import {
    ListBox,
    ListBoxToolbar,
    processListBoxData
} from '@progress/kendo-react-listbox';
import { TRANSFER_TO, TRANSFER_FROM } from '../../Models/constants';
import Notifications, { ERROR_NOTIFICATION, INFO_NOTIFICATION } from '../../../helpers/notifications';
import API from '../../../services/api';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

import validator from 'validator';

// Reac number format
import NumberFormat from 'react-number-format';

const SELECTED_FIELD = "selected";
const LinkBenefitandGroups = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');

    const [ithr, setITHR] = useState('0');
    const [ibam, setIBAM] = useState('0');

    const [confirmAdd, setConfirmAdd] = useState(false);
    const [addAnother, setAddAnother] = useState(false);
    const [showAddBtn, setShowAddBtn] = useState(false)

    const [selectedBeneficiaryUnit, setSelectedBeneficiaryUnit] = useState('');

    // * ListBox components state
    const [state, setState] = useState({
        availableGroups: [],
        addedGroups: []
    });



    useEffect(() => {
        getScenarioGroups()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getScenarioGroups = async () => {
        try {
            const resGroups = await API.get(`/Scenario/GetGroups?scenarioId=${props.scenarioId}`);
            if (resGroups.data.code !== 100) {
                Notifications.notify(t(resGroups.data.msg), ERROR_NOTIFICATION);
                return;
            }

            const availableGroupsList = resGroups.data.data.map((item, i) => {
                if (i === 0) {
                    item[SELECTED_FIELD] = true;
                } else {
                    item[SELECTED_FIELD] = false;
                }

                return item;
            });
            setState({
                ...state,
                availableGroups: availableGroupsList,
                addedGroups: []
            });

            //Used to know if the selected pop group is HouseHold or Individual. This to make a validation
            setSelectedBeneficiaryUnit(availableGroupsList[0].beneficiaryUnit);
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }
    }

    // * Sets the active item after click
    const handleItemClick = (event, data, connectedData) => {
        setState({
            ...state,
            [data]: state[data].map((item) => {
                if (item.name === event.dataItem.name) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else {
                    item[SELECTED_FIELD] = false;
                }

                return item;
            }),
            [connectedData]: state[connectedData].map((item) => {
                item[SELECTED_FIELD] = false;
                return item;
            }),
        });

        //todo Used to know if the selected pop group is HouseHold or Individual. This to make a validation
        setSelectedBeneficiaryUnit(event.dataItem.beneficiaryUnit);
    };

    // Click in the arrows of the lists
    const handleToolBarClick = async (e) => {
        const toolName = e.toolName || "";
        let result = processListBoxData(
            state.addedGroups,
            state.availableGroups,
            toolName,
            SELECTED_FIELD
        );

        const sameBeneficiaryUnit = state.addedGroups.every((e) => {
            return e.beneficiaryUnit === selectedBeneficiaryUnit
        })

        if (sameBeneficiaryUnit) {
            setState({
                ...state,
                availableGroups: result.listBoxTwoData,
                addedGroups: result.listBoxOneData,
            });
        } else {
            Notifications.notify(t('model.wrongPopGroup'), ERROR_NOTIFICATION);
        }
    };

    const add_benefit = () => {

        // * Validations
        // --- empty validations
        if (validator.isEmpty(ithr.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ithr.toString())) {
            Notifications.notify(t('model.ithr_number'), ERROR_NOTIFICATION);
            return false;
        }

        if (validator.isEmpty(ibam.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ibam.toString())) {
            Notifications.notify(t('model.ithr_number'), ERROR_NOTIFICATION);
            return false;
        }

        const data = {
            ithr_abam: ithr,
            ibam: ibam
        }

        props.handleAddBenefit(state.addedGroups, data);
        toggleConfirmAdd();
        toggleShowAddBtn();

        //toggleAddAnother()
    }


    const add_another_benefit = () => {

        // * Validations
        // --- empty validations
        if (validator.isEmpty(ithr.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ithr.toString())) {
            Notifications.notify(t('model.ithr_number'), ERROR_NOTIFICATION);
            return false;
        }

        if (validator.isEmpty(ibam.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ibam.toString())) {
            Notifications.notify(t('model.ithr_number'), ERROR_NOTIFICATION);
            return false;
        }

        const data = {
            ithr_abam: ithr,
            ibam: ibam
        }

        props.handleAddAnotherBenefit(state.addedGroups, data);
        toggleConfirmAdd();
        toggleShowAddBtn();

        //toggleAddAnother()
    }

    const toggleConfirmAdd = () => {
        setConfirmAdd(!confirmAdd);
    }
    const toggleAddAnother = () => {
        setAddAnother(!addAnother);
    }
    const toggleShowAddBtn = () => {
        setShowAddBtn(!showAddBtn);
    }

    return (
        <div className="container-fluid m-1 add_benefit_step_container">

            {/* confirm alert */}
            {confirmAdd &&
                <Dialog
                    className="ilo-delete-confirm"
                    title={t('scenarios.add_benefit.confirm_add_title')}
                    onClose={() => toggleConfirmAdd()}
                >
                    <p style={{ margin: "25px", textAlign: "center" }}>{t('scenarios.add_benefit.confirm_add')}</p>
                    <DialogActionsBar layout="end">
                        <button className="k-button" onClick={add_benefit}>{t('alerts.yes_btn')}</button>
                        <button className="k-button" onClick={toggleConfirmAdd}>{t('alerts.no_btn')}</button>
                    </DialogActionsBar>
                </Dialog>
            }

            {/* add another alert */}
            {addAnother &&
                <Dialog
                    className="ilo-alert-info"
                    title={t('scenarios.add_benefit.add_anoher_title')}
                    onClose={() => toggleAddAnother()}
                >
                    <p style={{ margin: "25px", textAlign: "center" }}>{t('scenarios.add_benefit.add_anoher')}</p>
                    <DialogActionsBar layout="end">
                        <button className="k-button" onClick={add_another_benefit}>{t('alerts.yes_btn')}</button>
                        <button className="k-button" onClick={props.goBack}>{t('alerts.no_btn')}</button>
                    </DialogActionsBar>
                </Dialog>
            }

            <div className="form-group row add_benefit_title">
                <div className="col-md-12 mb-2 pt-2">
                    <h4>{t('scenarios.add_benefit.link_with_groups_title', { name: props.selectedBenefit.name })}</h4>
                    {/* <h6>{t('scenarios.add_benefit.step2')}</h6> */}
                </div>
                <div className="form-group col-md-6">
                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.ithr_abam')}</label>
                    <NumberFormat
                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                        thousandsGroupStyle="thousand"
                        value={ithr}
                        decimalSeparator="."
                        displayType="input"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        onValueChange={(values) => {
                            setITHR(values.value);
                        }}
                    />
                </div>

                <div className="form-group col-md-6">
                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.ibam')}</label>
                    <NumberFormat
                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                        thousandsGroupStyle="thousand"
                        value={ibam}
                        decimalSeparator="."
                        displayType="input"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        onValueChange={(values) => {
                            setIBAM(values.value);
                        }}
                    />
                </div>
            </div>

            <div className="form-group form-row add_benefit_body">
                <div className="form-group col-md-6">
                    <label className="ilo_lbl_general">{t('scenarios.add_benefit.added_groups')}</label>
                    <ListBox
                        style={{
                            height: 400,
                            width: "100%",
                        }}
                        data={state.addedGroups}
                        textField="name"
                        selectedField={SELECTED_FIELD}
                        toolbar={() => {
                            return (
                                <ListBoxToolbar
                                    tools={[TRANSFER_FROM, TRANSFER_TO]}
                                    data={state.addedGroups}
                                    dataConnected={state.availableGroups}
                                    onToolClick={handleToolBarClick}
                                />
                            );
                        }}
                        onItemClick={(e) => handleItemClick(e, 'addedGroups', 'availableGroups')}
                    />

                </div>
                <div className="form-group col-md-6">
                    <label className="ilo_lbl_general">{t('scenarios.add_benefit.available_groups')}</label>
                    <ListBox
                        style={{
                            height: 380,
                            width: "100%",
                        }}
                        data={state.availableGroups}
                        textField="name"
                        selectedField={SELECTED_FIELD}
                        onItemClick={(e) => handleItemClick(e, 'availableGroups', 'addedGroups')}

                    />
                </div>
            </div>

            <div className="row arrows_position add_benefit_buttons">
                <div className="col-sm-12">
                    <button onClick={() => { props.goBack() }} className="btn btn-primary ilo-btn mr-2">{t('scenarios.add_benefit.cancel')}</button>
                    {/* <button
                        onClick={() => {
                            if (state.addedGroups.length !== 0) {
                                props.setLinkGroups(state.addedGroups);
                                props.changeView('benefitDetails');

                            } else {
                                Notifications.notify(t(`scenarios.add_benefit.no_groups_selected`), INFO_NOTIFICATION);
                            }

                        }}
                        className="btn btn-primary ilo-btn"
                    >{t('scenarios.add_benefit.setDetails')}</button> */}


                    <button
                        onClick={() => {
                            toggleAddAnother();
                        }}
                        className="btn btn-primary ilo-btn mr-2"
                    >{t('scenarios.add_benefit.add_benefit_btn')}</button>


                    <button
                        onClick={() => {

                            if (state.addedGroups.length !== 0) {
                                toggleConfirmAdd();
                            } else {
                                Notifications.notify(t(`scenarios.add_benefit.no_groups_selected`), INFO_NOTIFICATION);
                            }
                        }}
                        className="btn btn-primary ilo-btn"
                    >{t('scenarios.add_benefit.complete')}</button>


                </div>
            </div>

        </div>
    )
}

export default LinkBenefitandGroups;
